import { useMemo } from 'react';
import { makeRootClassName } from '../../../../utils';
export var useDialogContentClassName = function useDialogContentClassName(classPrefix, className) {
  return useMemo(function () {
    return makeRootClassName(classPrefix, className);
  }, [classPrefix, className]);
};